/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Go as Go,
  rec_Ir as Ir,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_Va as Va,
  rec__a as _a,
  rec_ga as ga,
  rec_ii as ii,
  rec_ji as ji,
  rec_qi as qi,
  rec_ra as ra,
  rec_ya as ya,
} from "../../runtime/index.jsx";
export function CambiosPendientes() {
  let [e, t] = (0, React.useState)([]),
    [n, r] = (0, React.useState)(!1),
    i = Go(),
    a = (0, React.useCallback)(() => {
      ga()
        .then(t)
        .catch(() => {});
    }, []),
    o = (0, React.useCallback)(async () => {
      r(!0);
      try {
        await Va();
      } finally {
        (r(!1), a());
      }
    }, [a]),
    s = (0, React.useCallback)(
      async (e) => {
        (await ya(e), await o());
      },
      [o],
    );
  if (
    ((0, React.useEffect)(() => {
      a();
      let e = () => a(),
        t = () => o(),
        n = (e) => {
          let { enviados: t, fallidos: n } = e.detail ?? {};
          (t > 0 &&
            i.ok(
              t === 1
                ? `Se envió el cambio que quedó pendiente`
                : `Se enviaron ${t} cambios pendientes`,
            ),
            n > 0 &&
              i.error(`${n} cambio(s) no se pudieron enviar — revisalos`),
            a());
        },
        r = () => {
          document.visibilityState === `visible` && o();
        };
      return (
        window.addEventListener(`pendientes-cambiaron`, e),
        window.addEventListener(`pendientes-sincronizados`, n),
        window.addEventListener(`online`, t),
        window.addEventListener(`focus`, r),
        document.addEventListener(`visibilitychange`, r),
        o(),
        () => {
          (window.removeEventListener(`pendientes-cambiaron`, e),
            window.removeEventListener(`pendientes-sincronizados`, n),
            window.removeEventListener(`online`, t),
            window.removeEventListener(`focus`, r),
            document.removeEventListener(`visibilitychange`, r));
        }
      );
    }, [a, o, i]),
    e.length === 0)
  )
    return null;
  let c = e.filter((e) => e.error),
    l = e.filter((e) => !e.error);
  return (
    <div
      className={`animar-entrada flex flex-col gap-2 rounded-2xl border border-(--warning-border) bg-(--warning-bg) px-3 py-2 text-sm`}
      children={[
        l.length > 0 && (
          <div
            className={`flex flex-wrap items-center gap-2`}
            children={[
              <Ir className={`h-4 w-4 shrink-0 text-(--warning)`} />,
              <span
                className={`min-w-0 flex-1 text-(--text-h)`}
                children={[
                  l.length === 1
                    ? `Tenés 1 cambio guardado que todavía no se envió`
                    : `Tenés ${l.length} cambios guardados que todavía no se enviaron`,
                  !navigator.onLine && ` — se mandan solos al volver la señal`,
                ]}
              />,
              <button
                type={`button`}
                onClick={o}
                disabled={n || !navigator.onLine}
                className={`shrink-0 rounded-full border border-(--border) bg-(--bg) px-3 py-1.5 text-xs font-medium text-(--text-h) transition hover:bg-(--accent-bg) disabled:opacity-50`}
                children={[
                  n &&
                    (0, JSXRuntime.jsx)(ii, {
                      className: `mr-1 inline h-3.5 w-3.5 animate-spin`,
                    }),
                  `Enviar ahora`,
                ]}
              />,
            ]}
          />
        ),
        c.map((e) => (
          <div
            key={e.clave}
            className={`flex flex-wrap items-start gap-2 border-t border-(--border)/60 pt-2 first:border-0 first:pt-0`}
            children={[
              (0, JSXRuntime.jsx)(qi, {
                className: `mt-0.5 h-4 w-4 shrink-0 text-(--error)`,
              }),
              <span
                className={`min-w-0 flex-1`}
                children={[
                  <span
                    className={`block text-(--text-h)`}
                    children={e.descripcion}
                  />,
                  <span
                    className={`block text-xs text-(--error)`}
                    children={e.error}
                  />,
                ]}
              />,
              <button
                type={`button`}
                onClick={() => s(e.clave)}
                className={`shrink-0 rounded-full border border-(--border) bg-(--bg) px-2.5 py-1 text-xs font-medium text-(--text-h) transition hover:bg-(--accent-bg)`}
                children={[
                  (0, JSXRuntime.jsx)(ji, {
                    className: `mr-1 inline h-3 w-3`,
                  }),
                  ` Reintentar`,
                ]}
              />,
              <button
                type={`button`}
                onClick={() => _a(e.clave)}
                aria-label={`Descartar este cambio`}
                className={`shrink-0 rounded-lg p-1 text-(--text) hover:text-(--error)`}
                children={(0, JSXRuntime.jsx)(ra, {
                  className: `h-4 w-4`,
                })}
              />,
            ]}
          />
        )),
      ]}
    />
  );
}
